/**
 * This is the base for Landr Product purchases, all other Prepare Purchase should extend it.
 */
class AbstractPreparePurchase {
    constructor() {
        this.invoicePreview = null;
        this.token = null;
        this.hasPaymentMethod = null;
        this.hasValidBillingAddress = null;
    }
}

export { AbstractPreparePurchase };
